import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import Communication from './communication';
import CounterExpertise from './counter-expertise';
import Remark from './remark';
import RimLines from './rim-lines';
import RimSideNav from './rim-side-nav';
import { RimViews } from '../../../../store/details/rim/model';
import Signing from './signing';
import ValueAndCause from './value-and-cause';
import VatAndPayment from './vat-and-payment';
import RimList from './rim-list';
import { connect } from 'react-redux';
import styles from './rim.module.css';
import withParams from '../../../common/withParams';

interface PropsFromState {
  readonly currentView: RimViews;
}

type AllProps = PropsFromState & ConnectedReduxProps & {
  params: {
    instructionId: number;
  };
};

class Rim extends React.Component<AllProps> {
  private get selectedPage() {
    switch (this.props.currentView) {
      case RimViews.valueAndCause:
        return <ValueAndCause {...this.props} />;
      case RimViews.rimLines:
        return <RimLines {...this.props} />;
      case RimViews.vatAndPayment:
        return <VatAndPayment {...this.props} />;
      case RimViews.counterExpertise:
        return <CounterExpertise {...this.props} />;
      case RimViews.signing:
        return <Signing {...this.props} />;
      case RimViews.remark:
        return <Remark {...this.props} />;
      case RimViews.communication:
        return <Communication {...this.props} />;
      default:
        return <div />
    }
  }

  public render() {
    return (
      <div className={styles.container}>
        <div className={styles.rimcontent}>
          <div className={styles.sideNavContent}>
            {this.selectedPage}
          </div>
          <div className={styles.sideNav}>
            <RimSideNav {...this.props} />
          </div>
        </div>
        <RimList {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim } }: ApplicationState): PropsFromState => ({
  currentView: detailsRim.currentView
});

export default connect(mapStateToProps)(withParams(Rim));
